import { Icon, IconProps } from "../Icon";

const ArrowHorizontal = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.41 26.59L7.83 23H28V21H7.83L11.41 17.41L10 16L4 22L10 28L11.41 26.59ZM28 10L22 4L20.59 5.41L24.17 9H4V11H24.17L20.59 14.59L22 16L28 10Z"
      fill="currentColor"
    />
  </Icon>
);

export default ArrowHorizontal;
